const shadows = {
	base: '0px 0px 6px rgba(48, 48, 48, 0.04)',
};

export default shadows;
